import React from "react";
import { Col, Row } from "react-bootstrap";
import LabelController from "../../../atoms/Label/LabelController";
import LabelInsideTextArea from "../../../atoms/InputController/LabelInside/Label-Inside-TextField-Controller/LabelInsideTextArea";

const CallDetailsSection = ({ ...props }) => {
  const { comment } = props.newLeadContent;
  const { errors, touched, inputValue } = props;
  return (
    <div className="box-container">
      <Row>
        <Col sm={6}>
          <LabelController label={comment.label} />
          <LabelInsideTextArea
            value={inputValue[comment.name]}
            name={comment.name}
            placeholder={comment.name}
            type={comment.type}
            onChange={props.onChange}
            label={comment.inputLabel}
            touched={touched}
            errors={errors}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CallDetailsSection;
